import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import "./ExternalTableStyle";
import ExternalTable from "components/viewer/ExternalTable";

const DashboardTable = React.memo((props) => {
  return (
    <>
      <ExternalTable />

    </>
  );
});

export default withRouter(DashboardTable);
